"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getProgressMeasureUpdatedEvent_1 = require("../helpers/getEvent/getProgressMeasureUpdatedEvent");
const getState_1 = require("../helpers/getState");
function applySetProgressCommand(command, user, content, states) {
    const events = [];
    const { contentId, userId, progressMeasure, timeStamp } = command;
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        const currentContent = getContent_1.getContentByContentId(content, contentId);
        const currentProgressMeasure = state.progressMeasure;
        state.progressMeasure = progressMeasure;
        state.lastAccessedOn = state.updatedAt = timeStamp;
        if (currentProgressMeasure !== state.progressMeasure) {
            if (currentProgressMeasure === 0 && state.progressMeasure > 0) {
                state.startedOn = timeStamp;
            }
            const { companyId } = user;
            const updatedProgressMeasure = state.progressMeasure;
            const contentType = getContentType_1.getContentType(currentContent);
            const progressMeasureUpdatedEvent = getProgressMeasureUpdatedEvent_1.getProgressMeasureUpdatedEvent(command, companyId, userId, content._id, contentType, currentProgressMeasure, updatedProgressMeasure);
            events.push(progressMeasureUpdatedEvent);
        }
    });
    return { states: updatedStates, events, enrolments: [], stateInteractions: [] };
}
exports.applySetProgressCommand = applySetProgressCommand;
//# sourceMappingURL=applySetProgressCommand.js.map